module.exports = __webpack_public_path__ + "static/logo-6aa83c85d9f933b40371053dc9c76b58.png";